import { c as _c } from "react/compiler-runtime";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "@refinedev/react-hook-form";
import { Button, Form, FormControl, FormField, FormItem, FormLabel, FormMessage, Input, Slider } from "@saridana-core/react-ui-kit";
import { TProduct } from "@shared/types";
import { PottedPlantIcon } from "@shared/ui/custom-icon";
import { formatCurrency } from "@shared/utils";
import { useState } from "react";
import { useIMask } from "react-imask";
import z from "zod";
import { calculateTotalRate, calculateTotalSum } from "../lib";
import { CalculatorResult } from "../types";
export function FixedRateCalculatorForm(t0) {
  const $ = _c(61);
  const {
    product
  } = t0;
  const {
    fixedRate,
    min,
    max,
    calculatorType
  } = product;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const formSchema = z.object({
      amount: z.string(),
      percent: z.number({
        error: _temp
      })
    });
    t2 = useForm;
    t1 = zodResolver(formSchema);
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== fixedRate?.defaultAmount || $[3] !== min) {
    t3 = fixedRate?.defaultAmount?.toString() || min.toString() || "0";
    $[2] = fixedRate?.defaultAmount;
    $[3] = min;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== fixedRate?.defaultAmount || $[6] !== fixedRate?.rates) {
    t4 = fixedRate?.rates && fixedRate?.defaultAmount ? fixedRate?.rates?.find(it => (fixedRate?.defaultAmount || 0) <= it.sum)?.percent || 2 : 2;
    $[5] = fixedRate?.defaultAmount;
    $[6] = fixedRate?.rates;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3 || $[9] !== t4) {
    t5 = {
      resolver: t1,
      defaultValues: {
        amount: t3,
        percent: t4
      }
    };
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const form = t2(t5);
  let t6;
  if ($[11] !== max || $[12] !== min) {
    t6 = {
      mask: Number,
      min,
      max,
      thousandsSeparator: "."
    };
    $[11] = max;
    $[12] = min;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const {
    ref: amountMaskRef,
    unmaskedValue
  } = useIMask(t6);
  const [result, setResult] = useState(null);
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = payload => {
      if (payload) {
        setResult({
          amount: calculateTotalRate(payload.amount, payload.percent, 1, 0)
        });
      }
    };
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const handleSubmit = t7;
  let t8;
  if ($[15] !== fixedRate || $[16] !== form) {
    t8 = () => {
      const values = form.getValues();
      let percentValue = 2;
      if (values.amount && fixedRate && fixedRate.rates) {
        const rates = fixedRate.rates;
        const amount = parseFloat(values.amount);
        const validRate = rates.find(it_0 => amount <= it_0.sum);
        if (validRate) {
          percentValue = validRate.percent;
        }
      }
      form.resetField("percent", {
        defaultValue: percentValue
      });
    };
    $[15] = fixedRate;
    $[16] = form;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const handleMapRates = t8;
  if (!fixedRate || calculatorType !== "fixedRate") {
    return null;
  }
  let t9;
  if ($[18] !== form) {
    t9 = form.handleSubmit(handleSubmit);
    $[18] = form;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== amountMaskRef || $[21] !== fixedRate.amountInputLabel || $[22] !== fixedRate.amountInputPlaceholder || $[23] !== fixedRate.currency || $[24] !== fixedRate.isShowSlider || $[25] !== form || $[26] !== handleMapRates || $[27] !== max || $[28] !== min || $[29] !== product.maxLabel || $[30] !== product.minLabel || $[31] !== unmaskedValue) {
    t10 = t11 => {
      const {
        field
      } = t11;
      return <FormItem>{fixedRate.amountInputLabel && <FormLabel className="text-lg mb-2 inline-block">{fixedRate.amountInputLabel}</FormLabel>}<FormControl><div><div className="inline-flex w-full relative"><span className="absolute top-[50%] left-4 text-lg md:text-xl text-gray-500 transform translate-y-[-50%]">{fixedRate.currency}</span><Input className="!p-4 min-h-[50px] md:min-h-[60px] text-lg md:!text-xl !pl-12" type="tel" inputMode="numeric" placeholder={fixedRate.amountInputPlaceholder || ""} defaultValue={field.value} ref={amountMaskRef as any} onInput={() => {
                form.resetField("amount", {
                  defaultValue: unmaskedValue ? unmaskedValue : undefined
                });
                handleMapRates();
              }} /></div>{fixedRate.isShowSlider && <div className="mt-4"><Slider value={[Number(field.value)]} min={Number(min)} max={Number(max)} step={Number(min)} onValueChange={t12 => {
                const [value] = t12;
                const val = new Intl.NumberFormat("id-ID", {
                  style: "decimal",
                  currency: "IDR",
                  notation: "standard",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                }).format(value);
                (amountMaskRef.current as any).value = val;
                form.resetField("amount", {
                  defaultValue: value.toString()
                });
                handleMapRates();
              }} /><div className="flex justify-between text-sm font-medium leading-[140%] text-gray-500 mt-2"><div>{product.minLabel || formatCurrency(min)}</div><div>{product.maxLabel || formatCurrency(max)}</div></div></div>}</div></FormControl><FormMessage className="text-sm md:text-base inline-block mt-2" /></FormItem>;
    };
    $[20] = amountMaskRef;
    $[21] = fixedRate.amountInputLabel;
    $[22] = fixedRate.amountInputPlaceholder;
    $[23] = fixedRate.currency;
    $[24] = fixedRate.isShowSlider;
    $[25] = form;
    $[26] = handleMapRates;
    $[27] = max;
    $[28] = min;
    $[29] = product.maxLabel;
    $[30] = product.minLabel;
    $[31] = unmaskedValue;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== form.control || $[34] !== t10) {
    t11 = <FormField control={form.control} name="amount" render={t10} />;
    $[33] = form.control;
    $[34] = t10;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== fixedRate.rateLabel || $[37] !== form) {
    t12 = t13 => {
      const {
        field: field_0
      } = t13;
      return <FormItem>{fixedRate.rateLabel && <FormLabel className="text-lg mb-2 inline-block">{fixedRate.rateLabel}</FormLabel>}<FormControl><div className="inline-flex w-full relative"><span className="absolute top-[50%] left-4 text-lg md:text-xl  transform translate-y-[-50%]"><PottedPlantIcon className="size-7 text-[#0DABAB]" /></span><Input className="!p-4 min-h-[50px] md:min-h-[60px] text-lg md:!text-xl !pl-14 !pr-12" type="number" inputMode="decimal" max={100} min={0} step={0.25} maxLength={3} placeholder="2%" value={field_0.value} onChange={event => {
              form.resetField("percent", {
                defaultValue: event.target.value && event.target.value !== "" ? parseFloat(event.target.value) : 0
              });
            }} /><span className="absolute top-[50%] right-4 text-lg md:text-xl text-gray-500 transform translate-y-[-50%]">%</span></div></FormControl><FormMessage className="text-sm md:text-base inline-block mt-2" /></FormItem>;
    };
    $[36] = fixedRate.rateLabel;
    $[37] = form;
    $[38] = t12;
  } else {
    t12 = $[38];
  }
  let t13;
  if ($[39] !== form.control || $[40] !== t12) {
    t13 = <FormField control={form.control} name="percent" render={t12} />;
    $[39] = form.control;
    $[40] = t12;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  const t14 = fixedRate.buttonText || "Hitung";
  let t15;
  if ($[42] !== t14) {
    t15 = <Button type="submit" className="text-lg md:text-xl h-14 md:h-[60px] md:px-8 w-full rounded-xl py-4 px-6 font-bold">{t14}</Button>;
    $[42] = t14;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  let t16;
  if ($[44] !== t11 || $[45] !== t13 || $[46] !== t15 || $[47] !== t9) {
    t16 = <form onSubmit={t9} className="space-y-7">{t11}{t13}{t15}</form>;
    $[44] = t11;
    $[45] = t13;
    $[46] = t15;
    $[47] = t9;
    $[48] = t16;
  } else {
    t16 = $[48];
  }
  let t17;
  if ($[49] !== form || $[50] !== t16) {
    t17 = <Form {...form}>{t16}</Form>;
    $[49] = form;
    $[50] = t16;
    $[51] = t17;
  } else {
    t17 = $[51];
  }
  let t18;
  if ($[52] !== fixedRate.totalSumLabel || $[53] !== result) {
    t18 = result && <><div className="mt-6">{fixedRate.totalSumLabel && result.amount && <div className="bg-[#F0FDFB] text-center space-y-3 rounded-xl py-5 px-4"><div className="text-lg sm:text-xl font-medium text-gray-900">{fixedRate.totalSumLabel}</div><div><h4 className="text-[28px] sm:text-[32px] text-[#0DABAB] font-bold leading-[130%]">{formatCurrency(result.amount)}</h4></div></div>}</div></>;
    $[52] = fixedRate.totalSumLabel;
    $[53] = result;
    $[54] = t18;
  } else {
    t18 = $[54];
  }
  let t19;
  if ($[55] !== fixedRate.agreementText) {
    t19 = fixedRate.agreementText && <div className="text-base font-normal text-gray-500 mt-4">{fixedRate.agreementText}</div>;
    $[55] = fixedRate.agreementText;
    $[56] = t19;
  } else {
    t19 = $[56];
  }
  let t20;
  if ($[57] !== t17 || $[58] !== t18 || $[59] !== t19) {
    t20 = <>{t17}{t18}{t19}</>;
    $[57] = t17;
    $[58] = t18;
    $[59] = t19;
    $[60] = t20;
  } else {
    t20 = $[60];
  }
  return t20;
}
function _temp(t0) {
  const {
    input
  } = t0;
  if (input === undefined) {
    return "Harus diisi";
  }
}